import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML =
`<custom-style>
<style>
  html {
    --horizontal-gradient: {
      background: -webkit-linear-gradient(left, rgba(255, 255, 255, 0) 3%, var(--detail-grey) 10%, var(--detail-grey) 90%, rgba(255, 255, 255, 0) 97%);
      background: -o-linear-gradient(left, rgba(255, 255, 255, 0) 3%, var(--detail-grey) 10%, var(--detail-grey) 90%, rgba(255, 255, 255, 0) 97%);
      background: linear-gradient(to right, rgba(255, 255, 255, 0) 3%, var(--detail-grey) 10%, var(--detail-grey) 90%, rgba(255, 255, 255, 0) 97%);
    }

    --vertical-gradient: {
      flex: 0 0 1px;
      height : auto;
      width : 1px;
      background-color: none;
      background-image: -webkit-linear-gradient(-180deg, rgba(255,255,255,0.00) 0%, var(--detail-grey) 16%, var(--detail-grey) 83%, rgba(255,255,255,0.00) 96%);
      background-image: -moz-linear-gradient(-180deg, rgba(255,255,255,0.00) 0%, var(--detail-grey) 16%, var(--detail-grey) 83%, rgba(255,255,255,0.00) 96%);
      background-image: -ms-linear-gradient(-180deg, rgba(255,255,255,0.00) 0%, var(--detail-grey) 16%, var(--detail-grey) 83%, rgba(255,255,255,0.00) 96%);
      background-image: -o-linear-gradient(-180deg, rgba(255,255,255,0.00) 0%, var(--detail-grey) 16%, var(--detail-grey) 83%, rgba(255,255,255,0.00) 96%);
      background-image: linear-gradient(-180deg, rgba(255,255,255,0.00) 0%, var(--detail-grey) 16%, var(--detail-grey) 83%, rgba(255,255,255,0.00) 96%)
    }

    --pseudo-hr: {
      content: ' ';
      display: block;
      height: 1px;
      width: 100%;
      background: var(--detail-grey);
    }

    --screen-reader-text: {
      border: 0;
      height: 1px;
      margin: -1px;
      overflow: hidden;
      padding: 0;
      position: absolute;
      width: 1px;
      word-wrap: normal;
    }

    --user-select-none: {
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    };

    --nowrap: {
      white-space: nowrap;
    }

    --focus: {
      outline-width: 2px;
      outline-style: solid;
      outline-color: Highlight;
    }

    --page-padding-xs: {
      padding-left : 15px;
      padding-right : 15px;
    }

    --page-padding-sm: {
      padding-left : 20px;
      padding-right : 20px;
    }

    --page-padding-md: {
      padding-left : 88px;
      padding-right : 88px;
    }

    --page-padding-lg: {
      padding-left : 70px;
      padding-right : 70px;
    }

    --page-fullwidth: {
      margin: auto calc(-1 * (100vw - 100%)/2);
    }

    --no-highlight-selection: {
      /* removes browser specific highlight when tapped */
      -webkit-tap-highlight-color: rgba(0,0,0,0);
      -moz-tap-highlight-color: rgba(0,0,0,0);
      -ms-tap-highlight-color: rgba(0,0,0,0);
      /* remove lookup on mobile browser */
      -webkit-user-select: none;  /* Chrome all / Safari all */
      -moz-user-select: none;     /* Firefox all */
      -ms-user-select: none;      /* IE 10+ */
      user-select: none;          /* Likely future */
    }
  }
</style>
</custom-style>`;

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
`<template>
  <style>
      :host {
        @apply --type-base;
        @apply --type16;
        color: var(--primary-active);
      }

      a,
      a:hover,
      a:focus {
        color: var(--primary-action);
        cursor: pointer;
      }

      a {
        text-decoration: var(--text-decoration, none);
      }

      a:hover, a:focus {
        color: var(--primary-hover);
        text-decoration: underline;
      }

      a:focus:not(:active) {
        @apply --focus;
      }

      /* Fix for removing underline from icon within a text link when present */
      a > dprd-icon {
        display: inline-block;
        text-decoration: none;
      }

      hr {
        height: 1px;
        border: 0;
        /* Fix thickness on other browsers aside from chrome */
        background-color: var(--detail-grey); /* Modern Browsers */
        color: var(--detail-grey); /* Old IE */
        margin: 0;
        padding: 0;
      }

      hr.gradient {
        @apply --horizontal-gradient;
      }

      .hidden,
      [hidden] {
        display: none !important;
      }

      [unresolved] {
        display: none !important;
      }

      /* Text meant only for screen readers. */
      .screen-reader-text {
        @apply --screen-reader-text;
      }

      .user-select-none {
        @apply --user-select-none;
      }

      .nowrap {
        @apply --nowrap;
      }

      .focus {
        @apply --focus;
      }

      .no-highlight-select {
        @apply --no-highlight-selection;
      }

      /* default mobile Portrait */
      .page-fullwidth {
        @apply --page-fullwidth;
      }

      .page-padding {
        @apply --page-padding-xs;
      }

      /* Tablet Portrait */
      @media (min-width: 768px) and (max-width: 1023px) {
        .page-padding {
          @apply --page-padding-sm;
        }
      }

      /* desktop */
      @media (min-width: 1024px) and (max-width: 1299px) {

        .page-padding {
          @apply --page-padding-md;
        }

        .page-nav-width {
          max-width: 940px;
          margin: auto;
        }

        .page-max-width {
          max-width: 1024px;
          margin: auto;
        }
      }

      /* large desktop */
      @media (min-width: 1300px) {

        .page-padding {
          @apply --page-padding-lg;
        }

        .page-nav-width {
          max-width: 940px;
          margin: auto;
        }

        .page-max-width {
          max-width: 1300px;
          margin: auto;
        }
      }

      .theme-description ul {
        list-style: disc;
        margin-left: var(--com-theme-pep-theme-description-ul-margin-left, 25px);
      }

      .theme-description ul li {
        margin-bottom: 3px;
      }

      .theme-description em {
        font-style: italic;
      }

    </style>
  </template>`;

  styleElement.register('com-theme-scaffolding');
  document.head.appendChild($_documentContainer.content);